import { Box } from "@chakra-ui/react";
import React from "react";
import { transparentBg } from "../../styles/styles";

type Props = {
	items: Array<{
		color?: string;
		id: string;
	}>;
};

export const ZStack = (props: Props) => {
	return (
		<Box
			display="inline-grid"
			gridAutoFlow="column"
			position="relative"
			sx={{
				"> div": {
					position: "relative",
					justifySelf: "start",
					gridRowStart: 1,
					gridColumnStart: 1,
				},
			}}
		>
			{props.items.map((item, index) => (
				<Box
					key={index}
					bg={item?.color ?? transparentBg.bg}
					bgSize="15%"
					w="20px"
					h="20px"
					borderRadius="full"
					zIndex={index}
					marginInlineStart={`calc(${index} * 15px)`}
					border="1px"
					borderColor="gray.200"
				/>
			))}
		</Box>
	);
};

export default ZStack;
